export const ActionTypes = {
  FETCH_ALL: 'services/operator/fetch_all',
  FETCH_ALL_SUCCESS: 'services/operator/fetch_all_success',
  SET_LOADER_STATUS: 'services/operator/set_loader_status',
  SET_ALL: 'services/operator/set_all',
  FETCH_LABOURS: 'services/operator/fetch_labours',
  SET_LABOURS: 'services/operator/set_labours',

  ADD_OR_UPDATE_OPERATOR: 'services/operator/add_or_update_operator',
  DELETE_OPERATOR: 'services/operator/delete_operator',
  IS_OPERATOR_ID_RESERVED: 'services/operator/is_operator_id_reserved',
  SET_IS_OPERATOR_ID_RESERVED: 'services/operator/set_is_operator_id_reserved',
  FETCH_OPERATORS_BY_DEPARTMENT_ID: 'services/operator/fetch_operators_by_department_id',
  SET_OPERATORS_BY_DEPARTMENT_ID: 'services/operator/set_operators_by_department_id',
  FETCH_FACTORY_LABOURS: 'services/operator/fetch_factory_labours',
  SET_FACTORY_LABOURS: 'services/operator/set_factory_labours',

  FETCH_FACTORY_LABOURS_BY_ID: 'services/operator/fetch_factory_labours_by_id',
  SET_FACTORY_LABOURS_BY_ID: 'services/operator/set_factory_labours_by_id',

  ADD_OPERATOR_SKILL: 'services/operator/add_operator_skill',
  UPDATE_OPERATOR_SKILL: 'services/operator/update_operator_skill',
  FETCH_OPERATOR_SKILLS: 'services/operator/fetch_operator_skills',
  SET_OPERATOR_SKILLS: 'services/operator/set_operator_skills',
  DELETE_OPERATOR_SKILL: 'services/operator/delete_operator_skill',

  IS_OPERATOR_ASSIGNED: 'services/operator/is_operator_assigned',
  SET_OPERATOR_ASSIGNED: 'services/operator/set_operator_assigned',
  SET_OPERATOR_ASSIGNED_LOADER_STATUS: 'services/operator/set_operator_assigned_loader_status',
};

const fetchAll = ({ operatorParams }) => ({
  operatorParams,
  type: ActionTypes.FETCH_ALL,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const fetchFactoryLabours = ({ factoryId }) => ({
  factoryId,
  type: ActionTypes.FETCH_FACTORY_LABOURS,
});

const setFactoryLabours = ({ factoryLaboursData }) => ({
  factoryLaboursData,
  type: ActionTypes.SET_FACTORY_LABOURS,
});

const fetchFactoryLaboursById = ({ factoryId }) => ({
  factoryId,
  type: ActionTypes.FETCH_FACTORY_LABOURS_BY_ID,
});

const setFactoryLaboursById = ({ factoryLaboursDataById }) => ({
  factoryLaboursDataById,
  type: ActionTypes.SET_FACTORY_LABOURS_BY_ID,
});

const fetchLabours = () => ({
  type: ActionTypes.FETCH_LABOURS,
});

const setLaboursData = ({ laboursData }) => ({
  laboursData,
  type: ActionTypes.SET_LABOURS,
});

const setAll = ({ allOperator }) => ({
  allOperator,
  type: ActionTypes.SET_ALL,
});

const addorUpdateOperator = ({ operatorData, actionName, operatorParams, caller }) => ({
  operatorData,
  actionName,
  operatorParams,
  caller,
  type: ActionTypes.ADD_OR_UPDATE_OPERATOR,
});

const deleteOperator = ({ id, operatorParams }) => ({
  id,
  operatorParams,
  type: ActionTypes.DELETE_OPERATOR,
});

const isOperatorIdReserved = ({ id, callback }) => ({
  id,
  callback,
  type: ActionTypes.IS_OPERATOR_ID_RESERVED,
});

const setIsOperatorIdReserved = ({ isReserved }) => ({
  isReserved,
  type: ActionTypes.SET_IS_OPERATOR_ID_RESERVED,
});

const fetchOperatorsByDepartmentId = ({ departmentId }) => ({
  departmentId,
  type: ActionTypes.FETCH_OPERATORS_BY_DEPARTMENT_ID,
});

const setOperatorsByDepartmentId = ({ departmentOperators }) => ({
  departmentOperators,
  type: ActionTypes.SET_OPERATORS_BY_DEPARTMENT_ID,
});

const addOperatorSkill = ({ skillParams }) => ({
  skillParams,
  type: ActionTypes.ADD_OPERATOR_SKILL,
});

const updateOperatorSkill = ({ skill }) => ({
  skill,
  type: ActionTypes.UPDATE_OPERATOR_SKILL,
});

const fetchOperatorSkills = ({ operatorParams }) => ({
  operatorParams,
  type: ActionTypes.FETCH_OPERATOR_SKILLS,
});

const setOperatorSkills = ({ operatorSkills }) => ({
  operatorSkills,
  type: ActionTypes.SET_OPERATOR_SKILLS,
});

const deleteOperatorSkill = ({ skillId, operatorId }) => ({
  skillId,
  operatorId,
  type: ActionTypes.DELETE_OPERATOR_SKILL,
});

const isOperatorAssigned = ({ operatorId }) => ({
  operatorId,
  type: ActionTypes.IS_OPERATOR_ASSIGNED,
});
const setOperatorAssigned = ({ operatorAssigned }) => ({
  operatorAssigned,
  type: ActionTypes.SET_OPERATOR_ASSIGNED,
});
const setOperatorAssignedLoader = ({ operatorAssignedLoader }) => ({
  operatorAssignedLoader,
  type: ActionTypes.SET_OPERATOR_ASSIGNED_LOADER_STATUS,
});

export default {
  fetchAll,
  fetchOperatorsByDepartmentId,
  setAll,
  setLoader,
  fetchLabours,
  setLaboursData,
  fetchFactoryLabours,
  setFactoryLabours,
  fetchFactoryLaboursById,
  setFactoryLaboursById,
  addorUpdateOperator,
  deleteOperator,
  isOperatorIdReserved,
  setIsOperatorIdReserved,
  setOperatorsByDepartmentId,
  addOperatorSkill,
  updateOperatorSkill,
  fetchOperatorSkills,
  setOperatorSkills,
  deleteOperatorSkill,
  isOperatorAssigned,
  setOperatorAssigned,
  setOperatorAssignedLoader,
};
